



























































import Vue from 'vue';
import VueUeditor from '../../../common/components/ui/VueUeditor/index.vue';
import Uploader from '../../../common/components/ui/Uploader/index.vue';
import settingsClient from '../../apis';

export default Vue.extend({
  components: {
    VueUeditor,
    Uploader,
  },
  props: {
    topic: {
      type: Object,
      default: null,
    },
  },
  data() {
    const title: string | undefined = undefined;
    const thumb: string | undefined = undefined;
    const description: string | undefined = undefined;
    const detail: string | undefined = undefined;
    const showCount = false;
    return {
      ueditorConfig: {
        initialFrameHeight: 200,
      },
      title,
      thumb,
      description,
      detail,
      showCount,
    };
  },
  methods: {
    editorReady(editorInstance: any) {
      editorInstance.setContent(this.detail || '');
      editorInstance.addListener('contentChange', () => {
        this.detail = editorInstance.getContent();
      });
    },
    afterUploadPic(file: any, comp: any) {
      const pic = comp.srcPath + '/' + file.data.result;
      this.thumb = pic;
    },
    confirmCreate() {
      if (this.validateCreate()) {
        if (this.topic && this.topic.id) {
          settingsClient.updateTopic({
            id: this.topic.id,
            name: this.title,
            shortDesc: this.description,
            longDesc: this.detail,
            pic: this.thumb,
            showCount: this.showCount,
          }).success((r: any) => {
            this.$Message.success('修改成功');
            this.$emit('refresh');
            this.$emit('close');
          }).failure((code: string, msg?: string) => {
            this.$Message.error(msg);
          }).error((e) => {
            this.$Message.error(e.toString());
          });
        } else {
          settingsClient.createTopic({
            name: this.title,
            shortDesc: this.description,
            longDesc: this.detail,
            pic: this.thumb,
            showCount: this.showCount,
          }).success((r: any) => {
            this.$Message.success('创建成功');
            this.$emit('refresh');
            this.$emit('close');
          }).failure((code: string, msg?: string) => {
            this.$Message.error(msg);
          }).error((e) => {
            this.$Message.error(e.toString());
          });
        }
      }
    },
    validateCreate(): boolean {
      if (!this.title || (this.title! as string).trim() === '') {
        this.$Message.warning('请填写标题');
        return false;
      } else if (!this.thumb) {
        this.$Message.warning('请选择配图');
        return false;
      } else if (!this.detail || (this.detail! as string).trim() === '') {
        this.$Message.warning('请填写详细介绍');
        return false;
      } else {
        return true;
      }
    },
  },
  mounted() {
    if (this.topic) {
      this.title = this.topic.name;
      this.thumb = this.topic.pic;
      this.description = this.topic.shortDesc;
      this.detail = this.topic.longDesc;
      this.showCount = this.topic.showCount;
    }
  },
});
